import { all } from "redux-saga/effects";

import getLaborContractSaga from "./getLaborContract";
import getProfileWorkSaga from "./getProfileWork";
import getProfileWorkBeforeSaga from "./getProfileWorkBefore";
import updateProfileWorkBeforeSaga from "./updateProfileWorkBefore";
import getFileLaborContractSaga from "./getFileLaborContract";
export default function* operationProcessSaga() {
  yield all([
    getLaborContractSaga(),
    getProfileWorkSaga(),
    getProfileWorkBeforeSaga(),
    updateProfileWorkBeforeSaga(),
    getFileLaborContractSaga(),
  ]);
}
